import { InvoicePayment } from './invoices.ts';
import { NamedEntityMinDto, SimpleCurrencyDto } from './other.ts';

export interface BankTransactionListItem {
    id: number;
    entryBookingDate: string;
    bankTransactionStatusTypeCode: string;
    entryDebtorName: string;
    entryDescription: string;
    entryReferenceNumber: string | null;
    entryAmountCurrencyTypeCode: string;
    entryAmount: number;
    isNonInvoiceTransaction: boolean;
    amountNoninvoice: number | null;
    remainingAmount: number;
    coveredRatio: number;
    coveredPercent: number;
    createdAt?: string;
    createdBy?: NamedEntityMinDto;
    lastModifiedAt?: string;
    lastModifiedBy?: NamedEntityMinDto;
}

export interface BankTransactionTotalsDto {
    entryAmountBreakdown: SimpleCurrencyDto[];
    limitExceeded: boolean;
}

export interface BankTransferInvoicePayment {
    invoicePaymentId?: number;
    invoiceId: number;
    companyCountryId: number;
    isConnected: boolean;
    invoiceNumber: string;
    invoiceDate: string;
    clientPartyName: string;
    outstandingBalanceInPaymentCurrency: string;
    amount?: string;
    amountCurrencyTypeCode: string;
    savedAmount?: string;
    savedAmountInTransactionCurrency?: string;
    invoicePaymentCurrencyTypeCode: string;
    conversionRate?: string;
    conversionDate?: string;
    readonly?: boolean;
}

export interface BankTransactionConversionRate {
    conversionDate: string;
    conversionRate: string;
}

export interface BankTransactionUpdateDto {
    id: number;
    amountNoninvoice: number | null;
    noninvoiceNotes: string | null;
    transactionNotes?: string | null;
    isNonInvoiceTransaction: boolean;
    invoicePayments: InvoicePaymentUpdateOrCreateDto[];
}

export interface InvoicePaymentUpdateOrCreateDto {
    invoicePaymentId?: number;
    invoiceId: number;
    amount?: string;
    amountInTransactionCurrency?: string;
}

export interface BankTransactionDetails extends BankTransactionListItem {
    entryTransactionId: string;
    bankStatementNumber: string | null;
    accountOwnerName: string;
    accountIban: string;
    noninvoiceNotes: string | null;
    transactionNotes?: string | null;
    isProcessedOutside: boolean;
    isNonInvoiceTransaction: boolean;
    isProcessedOutsideDisabled: boolean;
    isNonInvoiceTransactionDisabled: boolean;
    isConnectInvoiceDisabled: boolean;
    invoicePayments: InvoicePayment[];
}

export interface BankTransactionUpdateSummary {
    excludedDuplicateCount: number;
    savedCount: number;
    excludedDuplicates: BankTransactionUpdateSummaryListItem[];
    saved: BankTransactionUpdateSummaryListItem[];
}

interface BankTransactionUpdateSummaryListItem {
    accountIban: string;
    entryTransactionId: string;
}

export interface AccountIbanOption {
    accountIban: string;
}

export interface AccountOwnerNameOption {
    accountOwnerName: string;
}

export interface EntryDebtorNameOption {
    entryDebtorName: string;
}

export interface EntryDebtorIdOption {
    entryDebtorId: string;
}

export enum BankTransactionStatusType {
    NON_INVOICE = 'NON_INVOICE',
    NOT_FULLY_USED = 'NOT_FULLY_USED',
    FULLY_USED = 'FULLY_USED',
    FULLY_USED_UNPAID = 'FULLY_USED_UNPAID',
}
